import React, { PureComponent } from 'react';
import Icon from '~/core/scripts/components/icon';
import Utils from '~/core/scripts/utils';
const config = ARTICLE_CONFIG;

function getResultSentence(score) {
  if (score <= 40) {
    return 'Das Kapitel deutsche Teilung ist für Sie komplett erledigt.';
  } else if (score <= 75) {
    return 'Für Sie ist die innerdeutsche Grenze längst vergessen.';
  } else if (score <= 90) {
    return 'Sie wissen immerhin, wo Teile der Grenze verliefen.';
  } else if (score <= 98) {
    return 'Sie kennen den Verlauf der innerdeutschen Grenze ziemlich gut.';
  } else {
    return 'Sie sind ein echter Experte!';
  }
}

function getComparisonSentence(comparisonScore, userScore) {
  if (comparisonScore === 1) {
    return `Niemand hat den Grenzverlauf besser eingezeichnet als Sie.`;
  }

  if (comparisonScore === 0) {
    return `Niemand hat den Grenzverlauf schlechter eingezeichnet als Sie.`;
  }

  if (userScore <= 40) {
    return `Nur <strong>${(comparisonScore * 100).toFixed(1).replace('.', ',')} Prozent</strong> der Nutzer haben schlechter gezeichnet.`;
  }

  if (userScore <= 65) {
    return `Immerhin haben Sie besser gezeichnet als <strong>${(comparisonScore * 100).toFixed(1).replace('.', ',')} Prozent</strong> der Nutzer.`;
  }

  return `Sie haben genauer als <strong>${(comparisonScore * 100).toFixed(1).replace('.', ',')} Prozent</strong> der Nutzer gezeichnet.`;
}

function getSharingSentence(comparisonScore, userScore) {
  if (comparisonScore === 1) {
    return `Niemand hat den Grenzverlauf bisher besser eingezeichnet als ich.`;
  }

  if (comparisonScore === 0) {
    return `Grenze? Welche Grenze? Ich habe am schlechtesten von allen gezeichnet.`;
  }

  if (userScore <= 40) {
    return `Für mich ist die Teilung Deutschlands längst Geschichte. Nur ${(comparisonScore * 100).toFixed(1).replace('.', ',')} Prozent der Nutzer haben schlechter als ich gezeichnet.`;
  }

  if (userScore <= 65) {
    return `Weißt Du noch, wo die innerdeutsche Grenze verlief? Ich habe genauer als ${(comparisonScore * 100).toFixed(1).replace('.', ',')} Prozent der Nutzer gezeichnet.`;
  }

  return `Weißt Du noch, wo die innerdeutsche Grenze verlief? Ich habe genauer als ${(comparisonScore * 100).toFixed(1).replace('.', ',')} Prozent der Nutzer gezeichnet.`;
}

function getTwitterSentence(comparisonScore, userScore) {
  return getSharingSentence(comparisonScore, userScore) + ' ' + config.meta.ogUrl;
}

function getFacebookSentence(comparisonScore, userScore) {
  return getSharingSentence(comparisonScore, userScore) + '';
}

class Result extends PureComponent {

  onFbShare = () => {
    Utils.trackEvent('share', 1, 'class_C');
    FB.ui({
      method: 'share',
      href: config.meta.ogUrl,
      quote: getFacebookSentence(this.props.userScoreComp, this.props.userScore)
    }, resp => {
      console.log(resp);
    });
  }

  getRank() {
    if (this.props.userScore <= 65) {
      return 'bad';
    } else if (this.props.userScore <= 90) {
      return 'ok';
    } else {
      return 'good';
    }
  }

  render() {
    if (!this.props.userScore || this.props.step !== 'result') {
      return null;
    }

    if (process.env.NODE_ENV === 'development') {
      console.log('userScore', this.props.userScore);
      console.log('user Comparison', this.props.userScoreComp);
    }

    return (
      <div className="map__result-wrapper">
        <div className="map__result-inner">
          <div className={`map__score ${this.getRank()}`}>
            <div className="map__score-text">{getResultSentence(this.props.userScore)}</div>
            <div className="map__score-bottom">
              {!config.isStatic && <span className="map__score-comparison" dangerouslySetInnerHTML={{ __html: getComparisonSentence(this.props.userScoreComp, this.props.userScore) }} />}
              <span className="map__again" onClick={this.props.onDrawAgain}><Icon type="refresh"/> Nochmal zeichnen!</span>
            </div>
          </div>
          <div className="map__sharer">
            <div className="map__sharer-button fb" onClick={this.onFbShare}>
              <Icon type="fb" />Auf Facebook teilen
            </div>
            <div className="map__sharer-button tw">
              <Icon type="tw" />
              <a target="_blank" href={`https://twitter.com/intent/tweet?source=${encodeURIComponent(config.meta.ogUrl)}&text=${encodeURIComponent(getTwitterSentence(this.props.userScoreComp, this.props.userScore))}`}>
                Auf Twitter teilen
              </a>
            </div>
          </div>

        </div>
          <div className="map__result-count">
            Teilnehmer: {this.props.count}
            {config.isStatic ? <br /> : null}
            {config.isStatic ? `Stand: ${config.staticDate} / Die Anwendung wird zur Zeit nicht aktualisiert` : null}
          </div>
      </div>
    );
  }
}

export default Result;